enum ContactActionType {
  POST_CONTACT_REQUEST = "POST_CONTACT_REQUEST",
  POST_CONTACT_SUCCEEDED = "POST_CONTACT_SUCCEEDED",
  POST_CONTACT_FAILED = "POST_CONTACT_FAILED"
}

export default ContactActionType;
